<template>
  <div>
    <div class=" container">
      <el-button @click="openDialogs" round>新增专家</el-button>
      <el-button @click="allDel" round>删除专家</el-button>
      <el-table stripe v-loading="loading" class="tables" ref="multipleTable" :data="tableData" border
        tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="150" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="title" label="头衔" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="popularity" label="热度" width="100" show-overflow-tooltip>
        </el-table-column>>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <span class="menu-button" @click="openEdit(scope.row)">编辑</span>
              <el-popconfirm cancel-button-type="button" title="确定删除数据吗？" @confirm="del(scope.row)">
                <span class="menu-button" slot="reference" style="margin-left: 20px;">删除</span>
              </el-popconfirm>
              <!-- <span class="menu-button" style="margin-left: 20px;" @click="del(scope.row)">删除</span> -->
              <br>
              <span class="menu-button" @click="openMaterial(scope.row)">资料管理</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 50px;">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="10" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <el-form :rules="rules" ref="form" style="width: 100%" :border="true" label-width="80px" :model="formLabel">
        <el-form-item label="姓名" prop="name" required>
          <el-input v-model="formLabel.name"></el-input>
        </el-form-item>
        <el-form-item label="头衔" prop="title" required>
          <el-input v-model="formLabel.title" placeholder="不同头衔请换行后输入" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description" required>
          <el-input v-model="formLabel.description" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="热度" prop="popularity" required>
          <el-input v-model="formLabel.popularity" type="number"></el-input>
        </el-form-item>
        <el-form-item label="宣传头像" prop="profile" required>
          <el-upload class="avatar-uploader" action="" :http-request="getToken" :on-error="uploadError"
            :on-change="onProgress" :on-success="uploadSuccess" :show-file-list="false">
            <img v-if="formLabel.profile" :src="formLabel.profile" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeData">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from '@/utils/request';
import { getIndustryExpertList, DelIndustryExpert } from '@/api/tables/tables';
const qiniu = require("qiniu-js");
export default {
  name: "expert",
  components: {
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      type: "add",
      id: '',
      userId: '',
      // 七牛
      qiniuData: {
        token: '',
        bucket: '',
        root: '',
      },
      fileList: [],
      formLabel: {
        id: '',
        name: "",
        title: "",
        popularity: "",
        description: "",
        profile: ""
      },
      dialogVisible: false,
      tableData: [], //列表数据
      multipleSelection: [], //多选数据
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入头衔', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        popularity: [
          { required: true, message: '请输入热度', trigger: 'blur' }
        ],
        profile: [
          { required: true, message: '请选择图片', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getToken(upload) {
      request({
        url: 'api/LearningMaterials/QiniuToken',
        method: 'post',
      }).then((res) => {
        if (res.data.success) {
          this.qiniuData.token = res.data.data.token
          this.qiniuData.bucket = res.data.data.bucket
          this.qiniuData.root = res.data.data.root
          this.qiniuUpload(upload, res.data.data.token, res.data.data.bucket)
        }
      })
    },
    getList() {
      var obj = {
        "pageIndex": this.currentPage,
        "pageSize": this.pageSize,
      }
      getIndustryExpertList(obj)
        .then((res) => {
          if (res.data.success) {
            this.loading = false
            this.tableData = res.data.data.items
            this.total = res.data.data.totalCount
          }
        })
    },

    uploadError(err, file, fileList) {
      this.$message({
        message: "出错，请重试！",
        type: "error",
        center: true,
      });
    },
    // 上传成功 
    uploadSuccess(response, file, fileList) {
    },
    onProgress(e) {
    },
    // 上传
    qiniuUpload(upload, token, bucket) {
      let time = Date.now()
      let key = "pspWeb/uploadFile/" + time + upload.file.name;
      // console.log(key);
      const _this = this;
      let putExtra = {};
      let config = { useCdnDomain: true, region: qiniu.region.z0 };
      // file:图片数据;key:图片名称;token:服务端获取的token;putExtra:额外的参数;config:其他配置
      let observable = qiniu.upload(
        // bucket,
        upload.file,
        key,
        token,
        putExtra,
        config
      );
      let error = function (err) {
        console.log(err)
        _this.$message({
          message: "上传出错",
          type: "error",
        });
      };
      let complete = function (res) {
        // console.log(res)
        _this.formLabel.profile = _this.qiniuData.root + res.key;
      };
      let next = function (response) { };
      let subObject = {
        next: next,
        error: error,
        complete: complete,
      };
      let subscription = observable.subscribe(subObject);

    },
    // 打开弹窗页
    openDialogs() {
      this.type = "add"
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      })
    },
    // 页数切换
    handleCurrentChange() {
      this.loading = true
      setTimeout(() => {
        this.getList()
      }, 400);
    },
    // 打开编辑
    openEdit(row) {
      this.type = "edit"
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.id = row.id
        this.formLabel = JSON.parse(JSON.stringify(row));;
      })
    },
    // 新增编辑数据
    changeData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            var obj = {
              "name": this.formLabel.name,
              "title": this.formLabel.title,
              "popularity": this.formLabel.popularity,
              "description": this.formLabel.description,
              "profile": this.formLabel.profile
            }
          } else {
            var obj = {
              "id": this.id,
              "name": this.formLabel.name,
              "title": this.formLabel.title,
              "popularity": this.formLabel.popularity,
              "description": this.formLabel.description,
              "profile": this.formLabel.profile
            }
          }
          request({
            url: this.type == 'add' ? 'api/IndustryExpert/AddIndustryExpert' : 'api/IndustryExpert/UpdateIndustryExpert',
            method: 'post',
            data: obj
          }).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.loading = true;
              setTimeout(() => {
                this.getList();
              }, 1000);

            } else {
              this.$message.error('失败！');
            }
          })
          this.dialogVisible = false;
        } else {
          return false;
        }
      });

    },
    // 删除数据
    del(row) {
      DelIndustryExpert({
        ids: [row.id]
      })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.data,
              type: 'success'
            });
            this.loading = true;
            setTimeout(() => {
              this.getList();
            }, 1000);

          } else {
            this.$message.error(res.data.msg);
          }
        },
        )
    },
    allDel() {
      if (this.multipleSelection.length <= 0) {
        this.$message({
          message: '至少选择一条数据',
          type: 'warning'
        });
        return;
      }
      var ids = this.multipleSelection.map((item) => {
        return item.id
      })
      DelIndustryExpert({
        ids: ids
      })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.data,
              type: 'success'
            });
            this.loading = true;
            setTimeout(() => {
              this.getList();
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        },
        )
    },
    // 打开资料管理
    openMaterial(row) {
      this.$router.push({
        name: '/study',
        query: {
          id: row.id,
        }
      })
    },
    // 多选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }

    ,
    handleAvatarSuccess(res, file) {
      console.log(file)
      this.profile = URL.createObjectURL(file.raw);
      console.log(this.profile)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

  },

};
</script>

<style lang="scss" scoped>
.tables {
  margin-top: 30px;
}

.menu-button {
  color: #2970EC;
  cursor: pointer;

}

::v-deep.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
